import React from "react";
import {
  Table,
  Label,
  Segment,
  Button,
  Dimmer,
  Loader,
} from "semantic-ui-react";
import { Grids, commonLabels } from "../../../../redux/constants/Values";

export const MassSpecData = (props) => {
  const {
    detailsPageButtonIsClicked,
    massSpecDetailsData,
    isFetchingMassspecData,
  } = props;
  return (
    <>
      <Segment padded>
        <Label attached="top" size="big" className="bgBlue">
          {Grids.massSpec + " " + commonLabels.data}
          <Button
            primary
            onClick={detailsPageButtonIsClicked.bind(this, Grids.massSpec)}
            floated="right"
          >
            {commonLabels.viewAll}
          </Button>
        </Label>
        <Table
          className="displayTable"
          singleLine
          compact
          striped
          sortable
          celled
          textAlign="center"
        >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Display Name</Table.HeaderCell>
              <Table.HeaderCell>Value</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {isFetchingMassspecData ? (
            <Dimmer active inverted>
              <Loader size="mini">{commonLabels.fetching}</Loader>
            </Dimmer>
          ) : (
            <Table.Body>
              <Table.Row>
                <Table.Cell>
                  {massSpecDetailsData &&
                  massSpecDetailsData.length > 0 &&
                  massSpecDetailsData[0].mnemonicDisplayName !== "N/A"
                    ? massSpecDetailsData[0].mnemonicDisplayName
                    : massSpecDetailsData && massSpecDetailsData.length > 0
                    ? massSpecDetailsData[0].mnemonicName
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {massSpecDetailsData &&
                    massSpecDetailsData.length > 0 &&
                    massSpecDetailsData[0].mnemonicValue}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {massSpecDetailsData &&
                  massSpecDetailsData.length > 1 &&
                  massSpecDetailsData[1].mnemonicDisplayName !== "N/A"
                    ? massSpecDetailsData[1].mnemonicDisplayName
                    : massSpecDetailsData && massSpecDetailsData.length > 1
                    ? massSpecDetailsData[1].mnemonicName
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {massSpecDetailsData &&
                    massSpecDetailsData.length > 1 &&
                    massSpecDetailsData[1].mnemonicValue}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {massSpecDetailsData &&
                  massSpecDetailsData.length > 2 &&
                  massSpecDetailsData[2].mnemonicDisplayName !== "N/A"
                    ? massSpecDetailsData[2].mnemonicDisplayName
                    : massSpecDetailsData && massSpecDetailsData.length > 2
                    ? massSpecDetailsData[2].mnemonicName
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {massSpecDetailsData &&
                    massSpecDetailsData.length > 2 &&
                    massSpecDetailsData[2].mnemonicValue}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {massSpecDetailsData &&
                  massSpecDetailsData.length > 3 &&
                  massSpecDetailsData[3].mnemonicDisplayName !== "N/A"
                    ? massSpecDetailsData[3].mnemonicDisplayName
                    : massSpecDetailsData && massSpecDetailsData.length > 3
                    ? massSpecDetailsData[3].mnemonicName
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {massSpecDetailsData &&
                    massSpecDetailsData.length > 3 &&
                    massSpecDetailsData[3].mnemonicValue}
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>
                  {massSpecDetailsData &&
                  massSpecDetailsData.length > 4 &&
                  massSpecDetailsData[4].mnemonicDisplayName !== "N/A"
                    ? massSpecDetailsData[4].mnemonicDisplayName
                    : massSpecDetailsData && massSpecDetailsData.length > 4
                    ? massSpecDetailsData[4].mnemonicName
                    : ""}
                </Table.Cell>
                <Table.Cell>
                  {massSpecDetailsData &&
                    massSpecDetailsData.length > 4 &&
                    massSpecDetailsData[4].mnemonicValue}
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          )}
        </Table>
      </Segment>
    </>
  );
};

export default MassSpecData;
